import { render, staticRenderFns } from "./vip_detail.vue?vue&type=template&id=1959455d&scoped=true&"
import script from "./vip_detail.vue?vue&type=script&lang=js&"
export * from "./vip_detail.vue?vue&type=script&lang=js&"
import style0 from "./vip_detail.vue?vue&type=style&index=0&id=1959455d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1959455d",
  null
  
)

export default component.exports